import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './declaration.css';
import PopupModel from '../../popup-model/PopupModel'; // Path as provided
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import { checkSubmissionStatus } from '../../../services/candidate/api';
import { sendNotificationToClient } from '../../../services/candidate/notificationapi';

const Declaration = () => {
  const [isAgreed, setIsAgreed] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [submissionResult, setSubmissionResult] = useState(null);
  const navigate = useNavigate();
  const candidate_id = localStorage.getItem("user_name");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCheckboxChange = () => {
    setIsAgreed(!isAgreed);
  };

  const handleSubmit = () => {
    if (isAgreed) {
      setShowConfirmPopup(true);



    }
  };

  const closeConfirmPopup = () => {
    setShowConfirmPopup(false);
  };

  const handleFinalSubmit = async () => {
    setIsSubmitting(true);

    try {
      const response = await checkSubmissionStatus();
      setShowConfirmPopup(false); // Close confirmation popup



      // candidatenotification build here 
      // Build notification
      const candidateNotification = {
        title: "Candidate Submission Details",
        message: `Candidate ${candidate_id} has successfully submitted his/her details.`,
        senderId: candidate_id,
        userRole: "CANDIDATE",
        receiverId: "", // Set the appropriate receiver ID if available
        isRead: false,
        redirectUrl: "" // Add a redirect URL if needed
      };
      // add notification here to the candidate and the client as well . 
      await sendNotificationToClient(candidateNotification);


      if (response.data.success) {
        setSubmissionResult({
          isSuccess: true,
          title: "Success",
          message: "Application submitted successfully."
        });

        setTimeout(() => {
          navigate(`/candidate/candidate-dashboard`);
        }, 1500);

      } else {
        setSubmissionResult({
          isSuccess: false,
          title: 'Submission Error',
          message: response.message || 'Submission failed. Please complete all required sections.'
        });
      }
      setShowResultPopup(true); // Show result popup
    } catch (error) {
      setShowConfirmPopup(false); // Close confirmation popup
      setSubmissionResult({
        isSuccess: false,
        title: 'Submission Error',
        message: error.response?.data?.message || 'Submission failed. Please try again.'
      });
      setShowResultPopup(true); // Show result popup
    } finally {
      setIsSubmitting(false);
    }


  };

  const closeResultPopup = () => {
    setShowResultPopup(false);
    setSubmissionResult(null); // Clear result after closing
  };

  return (
    <>
      <h2 className='decl-header'>Declaration</h2>

      <div className="decl-container">
        <div className="decl-content-area">
          <p className="decl-text">
            This following page is regarding the previous details filled and attachments.
          </p>

          <ul className="decl-list">
            <li>Personal Details</li>
            <li>Address Details</li>
            <li>Education Details</li>
            <li>Employment Details (Not required for freshers)</li>
          </ul>

          <div className="decl-agreement">
            <label className="decl-checkbox-label">
              <input
                type="checkbox"
                checked={isAgreed}
                onChange={handleCheckboxChange}
              />
              <span className="custom-checkbox">
                {isAgreed && <FontAwesomeIcon icon={faCheck} className="check-icon" />}
              </span>
              I agree that all the details and attachments were filled by me.
            </label>
          </div>
        </div>

        <div className="decl-bottom-nav">
          <button className="decl-submit" disabled={!isAgreed} onClick={handleSubmit}>
            Submit <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>

        {showConfirmPopup && (
          <div className="popup-overlay">
            <div className="popup-content">
              <h3 className='popup-title'>Confirmation</h3>
              <p>Click OK to Submit the application.</p>
              {/* <p>Select Submit, If you are ready to Submit.</p> */}
              <div className="dec-action-btn">
                <button
                  className="decl-popup-close"
                  onClick={closeConfirmPopup}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>

                <button
                  className="decl-popup-submit"
                  onClick={handleFinalSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "OK"}
                </button>
              </div>
            </div>
          </div>
        )}

        <PopupModel
          show={showResultPopup}
          onClose={closeResultPopup}
          title={submissionResult?.title}
          message={submissionResult?.message}
          isSuccess={submissionResult?.isSuccess}
        />
      </div>
    </>
  );
};

export default Declaration;